export default __webpack_public_path__ + "static/media/mlodz4.5db13f56.jpg";